import { Component } from '@angular/core';
import { SiteService } from '@app/_services/site.service';
import { StoreService } from '@services/store.service';
import { TranslateModule } from '@ngx-translate/core';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgClass } from '@angular/common';



@Component({
    selector: 'app-footer-contacts',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.scss'],
    standalone: true,
    imports: [NgIf, MatIconModule, NgClass, ExtendedModule, TranslateModule]
})
export class ContactsComponent {
    showList: boolean = false;

    constructor(public store: StoreService,
        public siteService: SiteService) {

    }
}
